<template>
  <v-dialog v-model="dialogAddPositionLevel" persistent max-width="800px">
    <v-card class="pa-4">
        <v-card-title>
        <span class="dialog-memeber-title">เพิ่มระดับตำแหน่งงาน</span>
        <v-row justify="end" style="margin-top: -3%;">
          <v-btn
            x-small
            icon
            @click="closeDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
        <v-card-text>
            <v-row class="" justify=center>
              <v-col cols="12" class="mt-n2">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" class="d-flex align-center justify-end pa-0">
                <v-btn class="" dark outlined @click="addPosition()">
                  <v-icon left dark class="icon-eye-color" size="14px">fa-plus</v-icon>
                  <span class="icon-eye-color ra-text-in-button-position">เพิ่มระดับตำแหน่ง</span>
                </v-btn>
              </v-col>
            </v-row>
            <!-- แบบเพิ่มหลายตัว -->
            <v-row>
            <v-col cols="12">
             <div
              style="max-height: 500px"
              class="overflow-y-auto overflow-x-hidden">
            <div v-for="(input, k) in positionLevel" :key="k" class="pa-0 ma-0">
              <v-card class="mx-auto px-0 mb-5" style="border: 1px solid #EEEEEE;" elevation="0">
                <v-row style="background-color: #EFF4FD" class="pa-0 ma-0">
                  <v-col cols="10">
                    <v-col
                      cols="10"
                      class="pa-0 d-flex flex-row justify-start"
                    >
                      <span class="txt-head"
                        >ลำดับที่ {{ k + 1 }}<span class="ml-1"></span
                        ><span
                          class="txt-font"
                          style="color: grey; font-size: 14px;"
                          >&nbsp;(</span
                        ><span style="color: red;">*</span
                        ><span
                          class="txt-font"
                          style="color: grey; font-size: 14px;"
                          >กรอกข้อมูลให้ครบถ้วน)</span
                        ></span
                      >
                    </v-col>
                  </v-col>
                  <v-col
                    v-if="positionLevel.length > 1"
                    cols="2"
                    class="pa-0 d-flex flex-row align-center justify-end"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          dark
                          icon
                          tile
                          class="mr-2"
                          @click="remove(k)"
                          v-show="k || (!k && positionLevel.length > 1)"
                        >
                          <template v-slot>
                            <v-icon dark color="#D1392B" size="19px"
                              >mdi-delete-outline</v-icon
                            >
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">ลบข้อมูล</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row class="pl-5 pr-5 pt-2 pb-2 mb-n2">
                  <v-col cols="6" class="form-control pa-2">
                    <span>ชื่อระดับตำแหน่งงาน</span>
                    <v-text-field
                      v-model="positionLevel[k].positionLvName"
                      dense
                      outlined
                      placeholder="ชื่อระดับตำแหน่งงาน"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="form-control pa-2">
                    <span>ระดับตำแหน่ง</span>
                    <v-text-field
                      v-model.number="positionLevel[k].number"
                      dense
                      outlined
                      placeholder="ระดับตำแหน่ง"
                      :rules="[
                          v => { if (v == 0 || /^[0-9 ]+$/.test(v)) return true;
                                else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                              }
                      ]"
                      @keydown.space.prevent
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
          </v-col>
            </v-row>
            <!-- แบบเพิ่มตัวเดียว -->
            <!-- <v-row>
              <v-col cols="6">
                <span class="mb-0">ชื่อระดับตำแหน่ง</span>
                <v-text-field
                    v-model="namePositionLevel"
                    dense
                    outlined
                    placeholder="ชื่อระดับตำแหน่ง"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <span class="mb-0">เลขระดับ</span>
                <v-text-field
                    v-model="numPosition"
                    dense
                    outlined
                    placeholder="เลขระดับ"
                    :rules="[
                        v => { if (v && /^[0-9 ]+$/.test(v)) return true;
                               else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                             }
                    ]"
                    @keydown.space.prevent
                ></v-text-field>
              </v-col>
            </v-row> -->
        </v-card-text>
        <v-card-actions class="pr-5 mt-n10">
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline" dark outlined @click="closeDialog()">ยกเลิก</v-btn>
          <v-btn v-if="checkValueList === false" class="button-color" color="grey" disabled>บันทึกข้อมูล</v-btn>
          <v-btn v-else class="button-color" dark @click="submitData()">บันทึกข้อมูล</v-btn>
        </v-card-actions>
        <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        absolute
        text
        top
        app
      >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    </div>
      </v-card>
  </v-dialog>
</template>

<script>
import
{
// AddDataPositionNew
  addPositonsLevel
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
export default {
  components: {
  },
  data () {
    return {
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      positionLevel: [
        {
          positionLvName: '',
          number: ''
        }
      ],
      dialogAddPositionLevel: false,
      selectPosition: [],
      numPosition: '',
      namePositionLevel: '',
      tokenUser: this.$store.state.token
    }
  },
  beforeDestroy () {
    EventBus.$off('opendialogAddPositionLevel')
  },
  mounted () {
    EventBus.$on('opendialogAddPositionLevel', this.openDialogAddPositionLevel)
  },
  created () {
    // this.initSelectData()
  },
  watch: {
  },
  computed: {
    checkValueList: function () {
      var result = Boolean
      this.positionLevel.map((data) => {
        if (data.positionLvName === '' || data.number === '') {
          result = false
        } else {
          result = true
        }
      })
      return result
    }
  },
  methods: {
    // เพิ่มระดับตำแหน่ง
    addPosition () {
      this.positionLevel.push({
        positionLvName: '',
        number: ''
      })
    },
    // ลบข้อมูลระดับตำแหน่ง
    remove (index) {
      this.positionLevel.splice(index, 1)
      this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
      this.snackbarColor = 'success'
      this.snackbar = true
    },
    closeDialog () {
      this.positionLevel = [
        {
          positionLvName: '',
          number: ''
        }
      ]
      this.dialogAddPositionLevel = false
    },
    openDialogAddPositionLevel (value) {
      this.dialogAddPositionLevel = value
    },
    async submitData () {
      const positionLevels = {
        positionLevel: this.positionLevel
      }
      try {
        const res = await addPositonsLevel(positionLevels, this.tokenUser)
        if (res.success) {
          swal('สำเร็จ', 'คุณได้ทำการเพิ่มข้อมูลเรียบร้อยแล้ว', 'success', {
            button: false,
            timer: 2000
          })
          this.dialogAddPositionLevel = false
          this.positionLevel = [
            {
              positionLvName: '',
              number: ''
            }
          ]
          EventBus.$emit('closedialogAddPositionLevel')
        } else {
          swal('ผิดพลาด', 'มีข้อมูลนี้ในระบบแล้ว', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.dialog-memeber-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.2rem;
}
</style>
